import React, { useEffect, useState } from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ApiServices from 'services/ApiServices';
import {PictureAsPdf, ListAlt, Send} from '@material-ui/icons/';
import Form from 'components/Form/FormTwoColumns';
import {useStyles} from './style';
import { Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { functions } from "constants/index";
import MostrarPDFModal from 'components/PdfModal'
import BotonPersonalizado from 'components/BotonNormal'
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import DialogLoadingMessage from 'components/LoadingMessage/index'
import Alert from '@material-ui/lab/Alert';

const  FiltrosParaGenerarReporteDeCiudadanosGuatemaltecosResidentesEnElExtranjero= (props)=> {
    const classes = useStyles(),
    [base64, setBase64] = useState(''),
    [abrirMostrarPDFModal, setAbrirMostrarPDFModal] = useState(false),
    [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});
    let description = [
        {name: "Antes de continuar, revise que la información que ingresó esté correcta.",},
        {name: "Datos requeridos (*)."}
    ]

    const [elements,setElements] = useState({
        fechaInicial: { 
            idelement: "fechaInicial", value: null , label: "Fecha Inicial ", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['requireds'],
            errorMessages:['Ingrese fecha inicial'], isError:false, elementType:'date'
        },
        fechaLimite: { 
            idelement: "fechaLimite", value: null , label: "Fecha Limite ", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['requireds'], 
            errorMessages:['Ingrese fecha limite'], isError:false, elementType:'date' 
        },
    });

    const CerrarMostrarPDFModal = () => {
        setAbrirMostrarPDFModal(false)
    }

    const GenerarReporte = async () => {
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement( elements, setElements );
        if(allGood){
            setLoadingMessage({loading: true, title:'Generando reporte. Espere un momento por favor! ...'})
            var saveData = {
                fechaLimite: elements.fechaLimite.value || '',
                fechaInicial: elements.fechaInicial.value || '',
                estadosPadron: 0,
            };
            if(!elements.fechaInicial.value && elements.fechaLimite.value) {
                showMessagePersonalizedPosition('warning', '¡Oops! ' , 'Si ingresa una fecha limite, deberá ingresar una fecha inicial.', 'center');
                return setLoadingMessage({loading: false, title:''})
            }
            if(!elements.fechaLimite.value && elements.fechaInicial.value) {
                showMessagePersonalizedPosition('warning', '¡Oops! ' , 'Si ingresa una fecha inicial, deberá ingresar una fecha limite.', 'center');
                return setLoadingMessage({loading: false, title:''})
            }
            try {
                let response = await ApiServices.reportesEstadisticos.reporteRecuentoEmpadronadosEnExtranjero(saveData)
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message, 'center')
                }
                else{                    
                    setBase64(response.data)
                    setAbrirMostrarPDFModal(true)
                }
            } catch (exception) {
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }  
            setLoadingMessage({loading: false, title:''})
        }        
    };
    const DescargarPDF = () => {
        functions.downloadPDFFromStringBase64(base64, props.titulo+'.pdf');
    }
    const GeneraryDescargarReporteEnExcel = async () => {
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement( elements, setElements );
        if(allGood){
            setLoadingMessage({loading: true, title:'Generando reporte en Excel. Espere un momento por favor! ...'})
            var saveData = {
                fechaLimite: elements.fechaLimite.value || '',
                fechaInicial: elements.fechaInicial.value || '',
                estadosPadron: 0,
            };
            if(!elements.fechaInicial.value && elements.fechaLimite.value) {
                showMessagePersonalizedPosition('warning', '¡Oops! ' , 'Si ingresa una fecha limite, deberá ingresar una fecha inicial.', 'center');
                return setLoadingMessage({loading: false, title:''})
            }
            if(!elements.fechaLimite.value && elements.fechaInicial.value) {
                showMessagePersonalizedPosition('warning', '¡Oops! ' , 'Si ingresa una fecha inicial, deberá ingresar una fecha limite.', 'center');
                return setLoadingMessage({loading: false, title:''})
            }
            try {
                let response = await ApiServices.reportesEstadisticos.exportarExcelReporteRecuentoEmpadronadosEnExtranjero(saveData)
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning', '¡Oops! ' ,response.error.message, 'center')
                }
                else{                    
                    const fileName = props.titulo+".xlsx"
                    functions.downloadPDFFromStringBase64( response.data, fileName);
                    showMessagePersonalizedPosition('success','Bien!', props.titulo+' DESCARGADO CORRECTAMENTE.','center')
                }
            } catch (exception) {
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }  
            setLoadingMessage({loading: false, title:''})
        }        
    };
    return (
        <div>            
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <br/>
            <Container maxWidth="lg">        
                <Grid container >
                    <div className={classes.colorComponente} >
                        <Grid item xs={12}>
                            <div className={classes.centerTitle}><Divider /> <strong>Complete los filtros para generar el reporte</strong> <Divider /></div>
                        </Grid >
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                            <Form   elements= {elements}/>
                        </Grid>
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                            <Alert variant="outlined" severity="info" className={classes.alertStyle}>
                                Si desea visualizar el total de guatemaltecos residentes en el extranjero en el padrón electoral no colocar fecha inicial y limite.
                            </Alert>
                        </Grid>
                        {
                            description && (
                                <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                                    <List>
                                        {
                                            description.map((text, index) => {
                                                return (
                                                    <ListItem>
                                                        <ListItemIcon> <Send color="primary"/></ListItemIcon>
                                                        <ListItemText style={{color: 'black'}} primary={text.name}/>
                                                    </ListItem>
                                                )
                                            })                                
                                        }
                                    </List>
                                </Grid>
                            )
                        }                        
                        <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                            <BotonPersonalizado title={"Generar y mostrar reporte en PDF"}  botonPersonalizado={true} function={GenerarReporte} icon={<PictureAsPdf/>} /> 
                            <BotonPersonalizado title={"Generar reporte en Excel"}  botonPersonalizado={true} function={GeneraryDescargarReporteEnExcel} icon={<ListAlt/>} /> 
                        </Grid>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                </Grid>
            <MostrarPDFModal open={abrirMostrarPDFModal} handleClose={CerrarMostrarPDFModal} title={props.titulo} base64={base64} DescargarPDF={DescargarPDF}/>
            </Container>
        </div>
    );   
}
export default connect(mapStateToProps, mapDispatchToProps)(FiltrosParaGenerarReporteDeCiudadanosGuatemaltecosResidentesEnElExtranjero);